import { useTranslation } from 'react-i18next';

import { ImgViewer } from 'libs/ui';
import { ClosePicturesButton, ImageWrap, Row } from './ride-photos.styled';

export const RidePhotos = (props) => {
  const { close, row, cols } = props;
  const { t } = useTranslation();

  /**
   * get photo
   * @param {*} photo
   * @returns
   */
  const getPhoto = (photo) => {
    return row.data?.photos ? row.data.photos[photo] : null;
  };

  return (
    <Row>
      <td colSpan={cols}>
        <ImageWrap>
          <ImgViewer images={[getPhoto('photo_1')]} width={'33%'} height={'300px'} />
          <ImgViewer images={[getPhoto('photo_2')]} width={'33%'} height={'300px'} />
          <ImgViewer images={[getPhoto('photo_3')]} width={'33%'} height={'300px'} />
          <ClosePicturesButton onClick={close}>
            <i className="fa fa-arrow-up" />
            {t('buttons.Скрыть')}
          </ClosePicturesButton>
        </ImageWrap>
      </td>
    </Row>
  );
};
